import { Seo } from "../components/Seo";
import { SEO, WEBINAR } from "../data/content";
import { Hero } from "../components/home/Hero";
import { Marquee } from "../components/Marquee";
import { Positioning } from "../components/home/Positioning";
import { Universes } from "../components/home/Universes";
import { Method } from "../components/home/Method";
import { Differentiation } from "../components/home/Differentiation";
import { Founder } from "../components/home/Founder";
import { Team } from "../components/home/Team";
import { Offerings } from "../components/home/Offerings";
import { RealizationsPreview } from "../components/home/RealizationsPreview";
import { BeforeAfterSection } from "../components/home/BeforeAfterSection";
import { Testimonials } from "../components/home/Testimonials";
import { Figures } from "../components/home/Figures";
import { Simulator } from "../components/home/Simulator";
import { Webinar } from "../components/home/Webinar";
import { CtaBand } from "../components/home/CtaBand";

export default function Home() {
  return (
    <main data-testid="page-accueil">
      <Seo title={SEO.title} description={SEO.description} />
      <Hero />
      <Marquee />
      <Positioning />
      <Universes />
      <Method />
      <Differentiation />
      <Founder />
      <Team />
      <Offerings />
      <RealizationsPreview />
      <BeforeAfterSection />
      <Testimonials />
      <Figures />
      <Simulator />
      {WEBINAR.enabled && <Webinar />}
      <CtaBand />
    </main>
  );
}
